import styled, { css, keyframes } from 'styled-components';

const dimIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const riseIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-0.5rem) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const Backdrop = styled.div(
  ({ theme }) => css`
    animation: ${dimIn} 220ms ease-out both;
    background-color: rgba(41, 55, 73, 0.55);
    inset: 0;
    position: fixed;
    z-index: ${theme.zi.modal};

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  `,
);

export const Card = styled.div(
  ({ theme }) => css`
    animation: ${riseIn} 260ms cubic-bezier(0.22, 0.8, 0.36, 1) 80ms both;
    background-color: ${theme.co.neutral99};
    border-radius: ${theme.bo.mediumLarge};
    box-shadow: ${theme.sh.s3};
    color: ${theme.co.secondary20};
    padding: ${theme.sz.s5};
    position: absolute;
    right: 0;
    top: calc(100% + ${theme.sz.s3});
    transform-origin: top right;
    width: min(${theme.sz.s}, calc(100vw - ${theme.sz.s8}));
    z-index: ${theme.zi.modal + 2};

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  `,
);

export const Arrow = styled.span(
  ({ theme }) => css`
    border-bottom: ${theme.sz.s3} solid ${theme.co.neutral99};
    border-left: ${theme.sz.s3} solid transparent;
    border-right: ${theme.sz.s3} solid transparent;
    height: 0;
    position: absolute;
    right: ${theme.sz.s10};
    /* Overlap the card edge so antialiasing cannot leave a seam between them. */
    top: calc(1px - ${theme.sz.s3});
    width: 0;
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    color: ${theme.co.secondary20};
    font-family: ${theme.DEPRECATED_ty.openSans};
    font-size: ${theme.sz.s6};
    font-weight: ${theme.DEPRECATED_ty.bold};
    line-height: 1.25;
    margin: 0;
    padding-right: ${theme.sz.s12};
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    color: ${theme.co.secondary50};
    font-family: ${theme.DEPRECATED_ty.openSans};
    font-size: ${theme.sz.s4};
    line-height: 1.5;
    margin: ${theme.sz.s2} 0 0;
  `,
);

export const CloseButton = styled.button(
  ({ theme }) => css`
    align-items: center;
    background: none;
    border: 0;
    border-radius: ${theme.bo.round};
    color: ${theme.co.neutral10};
    cursor: pointer;
    display: inline-flex;
    font-size: ${theme.sz.s5};
    height: ${theme.sz.s10};
    justify-content: center;
    padding: 0;
    position: absolute;
    right: ${theme.sz.s2};
    top: ${theme.sz.s2};
    width: ${theme.sz.s10};

    /* Doubled class beats the session header's global icon fill rule. */
    && *,
    && svg {
      fill: ${theme.co.neutral10};
    }

    &:focus-visible {
      outline: ${theme.bo.mediumWidth} solid ${theme.co.secondary40};
      outline-offset: ${theme.bo.thinWidth};
    }
  `,
);
